import React from 'react';
import { routes } from 'routes/routes';
import { Separator } from '@/components/ui/separator';
import TmdbLogo from 'images/tmdb_logo.png';

interface PrivateFooterProps {
  customRef?: React.Ref<HTMLElement>;
}

const PrivateFooter: React.FC<PrivateFooterProps> = ({ customRef }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer ref={customRef} className="tw-bg-white tw-mt-auto">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-6">
        {/* Mobile Layout - Stacked */}
        <div className="tw-flex tw-flex-col tw-items-center tw-space-y-4 md:tw-hidden">
          <div className="tw-flex tw-items-center tw-space-x-4 tw-text-sm">
            <a
              href={routes.PRIVACY_POLICY}
              target="_blank"
              rel="noreferrer"
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href={routes.TERMS_CONDITIONS}
              target="_blank"
              rel="noreferrer"
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Terms &amp; Conditions
            </a>
            <a
              href={routes.CONTACT_US}
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Contact
            </a>
            <a
              href={routes.ABOUT}
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              About
            </a>
          </div>
          <div className="tw-flex tw-items-center tw-space-x-3 tw-text-sm tw-text-slate-600 tw-text-center">
            <span>© {currentYear} Superb Intelligence Inc. All Rights Reserved</span>
            <img src={TmdbLogo} alt="TMDB" className="tw-h-3" />
          </div>
        </div>

        {/* Desktop Layout - Inline with separators */}
        <div className="tw-hidden md:tw-flex tw-items-center tw-justify-between tw-text-sm tw-text-slate-600">
          <div className="tw-flex tw-items-center tw-space-x-3">
            <span>© {currentYear} Superb Intelligence Inc. All Rights Reserved</span>
            <img src={TmdbLogo} alt="TMDB" className="tw-h-3" />
          </div>
          <div className="tw-flex tw-items-center tw-space-x-4">
            <a
              href={routes.PRIVACY_POLICY}
              target="_blank"
              rel="noreferrer"
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Privacy Policy
            </a>
            <Separator orientation="vertical" className="tw-h-4" />
            <a
              href={routes.TERMS_CONDITIONS}
              target="_blank"
              rel="noreferrer"
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Terms &amp; Conditions
            </a>
            <Separator orientation="vertical" className="tw-h-4" />
            <a
              href={routes.CONTACT_US}
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              Contact
            </a>
            <Separator orientation="vertical" className="tw-h-4" />
            <a
              href={routes.ABOUT}
              className="tw-text-foreground hover:tw-text-foreground/80 tw-transition-colors"
            >
              About
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PrivateFooter;
